/** @format */
import { desktop } from '@mpb-com/feather/helpers/media-queries';
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { TRADE_ARROW_TRANSFORM } from './constants';
import { StyledProductAddToQuoteLinkProps } from './types';

export const wrapperStyles = css`
    position: relative;
    height: var(--layout-spacing-24);
`;

export const styles = ({
    $isAddingToQuote,
    $isAnimating,
}: StyledProductAddToQuoteLinkProps) => css`
    // Ensure these overwrite styles from Link component
    && {
        ${theme.typography.body_normal_highlight}
        animation-name: ${$isAnimating ? 'transition' : ''};
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0%);
        white-space: nowrap;
    }

    @keyframes transition {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    @keyframes trade-arrow-top {
        from {
            ${TRADE_ARROW_TRANSFORM.top.from}
        }

        to {
            ${TRADE_ARROW_TRANSFORM.top.to}
        }
    }

    @keyframes trade-arrow-top-hidden {
        from {
            ${TRADE_ARROW_TRANSFORM.topHidden.from}
        }

        to {
            ${TRADE_ARROW_TRANSFORM.topHidden.to}
        }
    }

    @keyframes trade-arrow-bottom {
        from {
            ${TRADE_ARROW_TRANSFORM.bottom.from}
        }

        to {
            ${TRADE_ARROW_TRANSFORM.bottom.to}
        }
    }

    @keyframes trade-arrow-bottom-hidden {
        from {
            ${TRADE_ARROW_TRANSFORM.bottomHidden.from}
        }

        to {
            ${TRADE_ARROW_TRANSFORM.bottomHidden.to}
        }
    }

    .link-icon {
        overflow: hidden;
        font-size: inherit;
    }

    .add-to-quote-icon {
        position: absolute;
    }

    .trade-arrow {
        transition: transform 0.3s ease-in-out;
        width: 0.75em !important;
        height: 0.75em !important;
        overflow: hidden;

        &.top {
            ${TRADE_ARROW_TRANSFORM.top.from}
        }

        &.top-hidden {
            ${TRADE_ARROW_TRANSFORM.topHidden.from}
        }

        &.bottom {
            ${TRADE_ARROW_TRANSFORM.bottom.from}
        }

        &.bottom-hidden {
            ${TRADE_ARROW_TRANSFORM.bottomHidden.from}
        }
    }

    &:hover {
        .trade-arrow {
            &.top {
                ${TRADE_ARROW_TRANSFORM.top.to}
            }

            &.top-hidden {
                ${TRADE_ARROW_TRANSFORM.topHidden.to}
            }

            &.bottom {
                ${TRADE_ARROW_TRANSFORM.bottom.to}
            }

            &.bottom-hidden {
                ${TRADE_ARROW_TRANSFORM.bottomHidden.to}
            }
        }
    }

    ${$isAddingToQuote &&
    css`
        .trade-arrow {
            &.top {
                animation: trade-arrow-top 0.6s infinite ease-in-out;
            }

            &.top-hidden {
                animation: trade-arrow-top-hidden 0.6s infinite ease-in-out;
            }

            &.bottom {
                animation: trade-arrow-bottom 0.6s infinite ease-in-out;
            }

            &.bottom-hidden {
                animation: trade-arrow-bottom-hidden 0.6s infinite ease-in-out;
            }
        }
    `}

    ${desktop(css`
        // Ensure these overwrite styles from Link component
        && {
            ${theme.typography.body_small_highlight};
            transform: translate(0%, 0%);
            left: 0;
        }
    `)}
`;
